<template>
    <div class="register-wrap">
        <bread-crumb :bread-list="breadList" />

        <div class="register-content">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">注册管理</span>
            </div>
            <div class="search-wrap">
                <div class="option-wrap">
                    <div class="option-item">
                        <span class="label">手机号</span>
                        <el-input class="search-input"
                                  size="small"
                                  placeholder="请输入手机号"
                                  v-model="selectForm.phone"
                                  @keyup.enter.native="searchQuery">
                            <i slot="suffix"
                               class="iconfont icon-search"
                               @click="searchQuery"></i>
                        </el-input>
                    </div>

                    <div class="option-item">
                        <span class="label">状态</span>
                        <el-select v-model="selectForm.status"
                                   placeholder="请选择"
                                   size="small"
                                   :style="{width: '240px'}"
                                   @change="selectChange"
                                   clearable>
                            <el-option label="全部"
                                       value="">
                            </el-option>
                            <el-option label="待认证"
                                       value="0">
                            </el-option>
                            <el-option label="认证中"
                                       value="1">
                            </el-option>
                            <el-option label="认证不通过"
                                       value="3">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>

            <div class="table-wrap">
                <el-table :data="dataList"
                          stripe
                          v-loading="loading"
                          style="width: 100%">
                    <el-table-column min-width="50px"
                                     label="序号">
                        <template slot-scope="scope">
                            <span>{{  scope.$index + (page.current - 1) * page.pageSize + 1 }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="phone"
                                     label="手机号">
                    </el-table-column>

                    <el-table-column prop="createTime"
                                     label="注册日期">
                    </el-table-column>

                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <div v-if="scope.row.authenticationStatus === 0"
                                 class="status-warp">
                                <el-badge is-dot
                                          type="info"
                                          class="item">
                                </el-badge>
                                <span class="status_text">待认证</span>
                            </div>
                            <div v-else-if="scope.row.authenticationStatus === 1"
                                 class="status-warp">
                                <el-badge is-dot
                                          type="success"
                                          class="item">
                                </el-badge>
                                <span class="status_text">认证中</span>
                            </div>
                            <div v-else-if="scope.row.authenticationStatus === 3"
                                 class="status-warp">
                                <el-badge is-dot
                                          type="danger "
                                          class="item">
                                </el-badge>
                                <span class="status_text">认证不通过</span>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作"
                                     width="100">
                        <template slot-scope="scope">
                            <span @click="handleDeleteClick(scope.row.iuid)"
                                  class="link-btn">删除</span>
                            <span v-if="scope.row.authenticationStatus !== 0"
                                  @click="handleViewClick(scope.row.iuid)"
                                  class="link-btn">查看</span>
                        </template>
                    </el-table-column>
                    <div slot="empty"
                         class="table-none">
                        <div>
                            <svg-icon icon-class="none1" />
                        </div>
                        <span>暂无数据</span>
                    </div>
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination background
                               @current-change="handlePageChange"
                               :current-page.sync="page.current"
                               :page-size="page.pageSize"
                               layout="total, prev, pager, next, jumper"
                               :total="page.total">
                </el-pagination>
            </div>
        </div>
        <message-box :dialog-visible="dialogVisible"
                     :id="iuid"
                     warning-text="是否确认删除？"
                     @handleConfirm="handleConfirm"
                     @handleClose="handleClose" />
    </div>
</template>

<script>
import MessageBox from '@/components/MessageBox'
import { postPageAccount, deleteAccount } from '@/api/register'
export default {
    name: 'registerList',
    data () {
        return {
            loading: false,
            dialogVisible: false,
            breadList: [{ label: '用户管理' }, { label: '注册管理' }],
            dataList: [],
            iuid: '',
            selectForm: {
                phone: '',
                status: ''
            },
            page: {
                current: 1,
                total: 1,
                pageSize: 10
            }
        }
    },
    components: {
        MessageBox
    },
    methods: {
        // 查看
        handleViewClick (iuid) {
            this.$router.push({
                name: 'registerDetail',
                query: { iuid: iuid }
            })
        },
        // 删除
        handleDeleteClick (iuid) {
            this.dialogVisible = true
            this.iuid = iuid
        },
        // 确认删除
        async handleConfirm () {
            this.dialogVisible = false
            this.loading = true
            const { state } = await deleteAccount(this.iuid)
            if (state === 200) {
                this.$message({
                    message: '删除成功！',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '2000'
                })
                this.query(this.page.current)
            }
        },
        // 关闭删除弹窗
        handleClose () {
            this.dialogVisible = false
        },
        // 翻页
        handlePageChange (val) {
            this.query(val)
        },
        // 重置
        resetQuery () {
            this.selectForm.phone = ''
            this.selectForm.status = ''
            this.query(1)
        },
        searchQuery () {
            this.query(1)
        },
        async queryAccountList () {
            let status = []
            if (this.selectForm.status) {
                status = [this.selectForm.status]
            } else {
                status = ['0', '1', '3']
            }
            let param = {
                phone: this.selectForm.phone,
                status: status,
                size: this.page.pageSize,
                current: this.page.current
            }
            this.dataList = []
            this.loading = true
            const { results, total } = await postPageAccount(param)
            this.loading = false
            this.page.total = total
            this.dataList = results
        },
        // 下拉框change事件
        selectChange () {
            this.query(1)
        },
        query (val) {
            this.page.current = val
            this.queryAccountList()
        }
    },
    mounted () {
        this.query(1)
    }
}
</script>

<style lang="scss">
.register-wrap {
    height: calc(100% - 70px);
    .status-warp {
        line-height: 12px;
        .el-badge {
            height: 10px;
            .el-badge__content {
                width: 6px;
                height: 6px;
            }

            .el-badge__content--success {
                background: #4acfb1;
            }
            .el-badge__content--info {
                background: #cccccc;
            }
        }
        .status_text {
            margin-left: 10px;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #333333;
            line-height: 12px;
        }
    }
    .register-content {
        height: 100%;
        box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
        margin: 20px;
        padding: 0;
        background: #fff;
        overflow: auto;
        .title-wrap {
            margin: 20px 20px 0;
            height: 16px;
            line-height: 16px;
            .icon-tongyongbiaotiicon {
                color: $color-primary;
                font-size: 16px;
                vertical-align: middle;
            }
            .title-text {
                font-size: 14px;
                color: #333333;
                margin-left: 10px;
                display: inline-block;
                height: 16px;
                line-height: 16px;
                vertical-align: middle;
            }
        }

        .search-wrap {
            .option-wrap {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                margin: 20px 0;
                .option-item {
                    display: flex;
                    align-items: center;
                    .label {
                        padding-right: 10px;
                        font-size: 14px;
                        color: #666;
                        margin-left: 20px;
                    }
                    &:last-child {
                        margin-right: 0;
                    }
                    .el-input {
                        .el-input__inner {
                            height: 32px;
                        }
                    }
                }
                .select-btn-wrap {
                    font-size: 0;
                    margin-top: 20px;
                    .el-button--small {
                        width: 80px;
                        padding: 8px 15px;
                        font-size: 14px;
                    }
                    .el-button--info.is-plain {
                        background: #f5f5f5;
                        border-color: #cccccc;
                        color: #666;
                    }
                }
            }
        }

        .table-wrap {
            padding: 0 20px;
            .table-none {
                height: 400px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .icon {
                    font-size: 100px;
                }
                span {
                    line-height: 14px;
                }
            }
            .link-btn {
                color: $a-link;
                cursor: pointer;
                font-size: 12px;
                display: inline-block;
                height: 14px;
                line-height: 14px;
                border-right: 1px solid $a-link;
                margin-right: 6px;
                padding-right: 6px;
                &:last-child {
                    border-right: none;
                    margin-right: 0;
                    padding-right: 0;
                }
            }
        }
        .pagination-wrap {
            padding: 0 20px;
        }
    }
}
</style>
